import { Box } from '@mui/material'
import { TRAFFIC_URLS } from '../../constants'
import defaultBannerImage from '../../../../assets/images/phatnguoibanner.jpg'
import vnpayBannerImage from '../../../../assets/images/VNPAY/phatnguoibanner.jpg'
import './index.scss'
import { useAppParamsContext } from '../../../../context/AppParamsContext'
import { PARTNER_NAME_MINI_APP } from '../../../../constants/partnerNameMiniApp'

const BANNER_IMAGE_MAPPING = {
  [PARTNER_NAME_MINI_APP.VNPAY]: vnpayBannerImage,
  DEFAULT: defaultBannerImage
}

export default function Banner({ isEmbeddedView = false }) {
  const { partnerName } = useAppParamsContext()
  const bannerHref = !isEmbeddedView && TRAFFIC_URLS.trafficFineWeb
    ? `${TRAFFIC_URLS.trafficFineWeb}/automated-traffic-fine-notification/vehicles?isEmbeddedView=true`
    : undefined

  const Wrapper = bannerHref ? 'a' : 'div'

  const bannerImage = BANNER_IMAGE_MAPPING[partnerName] || BANNER_IMAGE_MAPPING.DEFAULT

  return (
    <Box className="TrafficViolationsBanner_wrapper">
      <Box className="TrafficViolationsBanner_inner">
        <Wrapper
          className="TrafficViolationsBanner_link"
          {...(bannerHref ? { href: bannerHref, target: '_blank', rel: 'noreferrer' } : {})}>
          <img src={bannerImage} alt="Banner" className="TrafficViolationsBanner_image" />
        </Wrapper>
      </Box>
    </Box>
  )
}
